// @ts-nocheck

const commonStateElement = document.querySelector("#common-state");

/**
 * parse common state
 * @returns {{ cart: { version: string, code: string }, translations: Object, localization: Object }}
 */
function parseCommonState() {
    try {
        return JSON.parse(commonStateElement.innerHTML);
    } catch (e) {
        console.error("error on parse common state", e);
        throw e;
    }
}
const parsedCommonState = parseCommonState();

parsedCommonState.translations = new Proxy(parsedCommonState.translations, {
    get(target, prop, receiver) {
        const translation = target[prop];

        if (!translation) {
            console.error(`Failed to find translation for literal: "${prop}"`);
            return prop;
        }

        return translation;
    },
});

export const commonState = parsedCommonState;

export function updateCommonState(newState) {
    Object.assign(commonState, newState);
}
